export default __webpack_public_path__ + "static/media/service_mockup2.266e02c5.png";